import BlockViz from "../../../../src/charts/blockviz.js";
import * as React from 'react';
export default {
  BlockViz,
  React
};